"use client";

import type { ReactNode } from "react";
import { usePathname } from "next/navigation";
import { pulseViewForPath } from "@/lib/dashboard/pulse-views";
import { PulsePageLoading } from "./pulse-loading";

/** Ancestor fallbacks can appear before the company layout has resolved. */
export function PulseRouteLoading({ children }: { children: ReactNode }) {
  const view = pulseViewForPath(usePathname());
  return view ? <PulsePageLoading view={view} /> : children;
}
